
import { autoWebViewJs } from "@droid/android";
import { Box, NoSsr } from "@mui/material";
import { initDeepLinkRouter } from "@src/libs/mc/main/DeepLinkRouter";
import { mainController } from "@src/libs/mc/main/MainController";
import { AnimatePresence, motion } from "framer-motion";
import { AppProps } from "next/app";
import { useRouter } from "next/router";
import { Fragment, useEffect, useState } from "react";
import { Toaster } from 'react-hot-toast';
import { AppThemeProvider } from "@app/theme";




export default function AppContainer({ Component, pageProps }: AppProps) {
  const [initialized, setInitialized] = useState(false)
  const [loading, setLoading] = useState(false)
  const router = useRouter()
  useEffect(() => {
    if (initialized || loading) return
    setLoading(true)
    async function init() {
      // i18nInit()
      await mainController.init()
      setInitialized(true)
      setLoading(false);
      // setTimeout(()=>{
      //   autoWebViewJs?.onDocumentReady()
      // }, 1000 * 1)
    }
    init()
  }, [initialized, loading])
  useEffect(()=>{
    if(!initialized)return;
    if(!router)return;
    initDeepLinkRouter(router)
  }, [router, initialized])
  return (

    <Fragment>
      <NoSsr>
        <AppThemeProvider>
          <Box sx={{ padding: "5px", minHeight: '100vh', bgcolor: 'background.default', color: 'text.primary' }} id={"mui-root-container"} maxWidth="lg" >
            {initialized ? <Component {...pageProps} /> : <Box>loading...</Box>}
            <Toaster />
          </Box>
        </AppThemeProvider>
      </NoSsr>
    </Fragment>


  );
}